import {make} from "vuex-pathify";

const state = {
    showAppCreator: false,
    showWebhookEditor: false,
    showTokenGenerator: false,
    showEventForm: false,
    showEventExampleViewer: false
}
const mutations = make.mutations(state)

const actions = {}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
